import(/* webpackMode: "eager" */ "/vercel/path0/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Figtree\",\"arguments\":[{\"adjustFontFallback\":false,\"display\":\"swap\",\"subsets\":[\"latin\"]}],\"variableName\":\"figtree\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/src/app/layout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/app/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/src/styles/globals.css");
